// extracted by mini-css-extract-plugin
var _1 = "AttachServiceRequestsStatusModalFields-modulecheckboxLabel__cpKQ3";
var _2 = "AttachServiceRequestsStatusModalFields-modulecheckboxLabelTitle__Poc1N";
export { _1 as "checkboxLabel", _2 as "checkboxLabelTitle" }
